import { AppBar, Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { SiteToolbar } from "./SiteToolbar";

export interface Props {
  title: string;
  backTo?: string;
}

function SiteHeader({ title, backTo }: Props) {
  const navigate = useNavigate();
  return (
    <AppBar
      data-id="app-bar-site"
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: "background.paper",
        borderBottom: 1,
        borderColor: "divider",
        color: "text.primary"
      }}
    >
      <SiteToolbar />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: { xs: 1.5, sm: 3 },
          pb: 1
        }}
      >
        <IconButton
          color="inherit"
          aria-label="Go back"
          onClick={() => navigate(backTo ?? "/")}
        >
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <Typography
          variant="h6"
          component="h1"
          sx={{ minWidth: 0, overflowWrap: "anywhere" }}
        >
          {title}
        </Typography>
      </Box>
    </AppBar>
  );
}
export default SiteHeader;
